import { useEffect, useState } from 'react';
import { useSession } from '@/contexts/LitSessionProvider';
import { useRouter } from 'next/router';
import useLitAuth, { delay } from '@/hooks/LitSessionContext/useLitAuth';
import { getMFASessionSig } from '@/lib/auth/mfa';
import { SESSION_LENGTHS } from '@/hooks/LitSessionContext/useLitSession';
import { toast } from 'sonner';
import { ExtendedProviderType, IExtendedRelayPKP } from '@shared/types/lit-protocol';
export const useOnboarding = () => {
  const {
    clients,
    PKP,
    litSession,
    setLitSession,
    MFAInfo,
    setMFAInfo,
    sessionLength,
    currentAuthMethod
  } = useSession();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [mfaLoading, setMFALoading] = useState(false);
  const [mfaProgress, setMFAProgress] = useState(0);
  const [progressBar, setProgressBar] = useState(0);
  const {
    authIn: WalletAuthIn,
    mint: WalletMint,
    createSession: WalletSessionCreate,
    loading: ethWalletLoader,
    progressBar: ethWalletProgressBar
  } = useLitAuth({
    authType: 'ethwallet'
  });
  const {
    authIn: AppleAuthIn,
    mint: AppleMint,
    createSession: AppleSessionCreate,
    loading: appleLoader,
    progressBar: appleProgressBar
  } = useLitAuth({
    authType: 'apple'
  });
  const {
    authIn: GeniusGoogleAuthIn,
    mint: GeniusGoogleMint,
    createSession: GeniusGoogleSessionCreate,
    loading: googleLoader,
    progressBar: googleProgressBar
  } = useLitAuth({
    authType: 'genius-google'
  });
  useEffect(() => {
    async function mfaSessionSig() {
      try {
        console.log('start getMFASessionSig');
        setMFAProgress && setMFAProgress(25);
        const _MFASessionSig = await getMFASessionSig(PKP, currentAuthMethod, MFAInfo.authMethod, clients.litNodeClient, sessionLength || SESSION_LENGTHS['1 week'], litSession, setMFAProgress);
        console.log('_MFASessionSig', _MFASessionSig);
        if (!_MFASessionSig) {
          throw new Error('Error creating a session with your two-factor authentication method.');
          return;
        }
        setLitSession(_MFASessionSig);
        setMFAInfo(prev => ({
          ...prev,
          MFALoggedIn: true,
          sessionSigs: _MFASessionSig
        }));
      } catch (e) {
        toast.error('Error creating a session with your two-factor authentication method.');
      } finally {
        setMFALoading(false);
      }
    }
    if (clients?.litNodeClient?.ready && MFAInfo?.presentMFAInfo?.authId && MFAInfo?.authMethod?.accessToken && !MFAInfo?.MFALoggedIn) {
      setMFALoading(true);
      mfaSessionSig();
    }
  }, [clients, MFAInfo]);
  useEffect(() => {
    const _progressBar = mfaLoading ? mfaProgress : googleProgressBar || appleProgressBar || ethWalletProgressBar;
    setProgressBar(_progressBar);
  }, [mfaLoading, mfaProgress, googleProgressBar, appleProgressBar, ethWalletProgressBar]);
  const runAuthFlow = async (type: ExtendedProviderType) => {
    console.log('type........', type, 'wuji');
    try {
      setLoading(true);
      let authResponse, mintResponse, sessionResponse, authMethod;
      if (type == ExtendedProviderType.Apple) {
        authMethod = await AppleAuthIn();
      } else if (type == ExtendedProviderType.GoogleG) {
        authMethod = await GeniusGoogleAuthIn();
      } else if (type == ExtendedProviderType.EthWallet) {
        authMethod = await WalletAuthIn();
        if (authResponse?.needsMint) {
          mintResponse = type === 'ethwallet' ? await WalletMint(authMethod) : null;
        }
        const pkp = mintResponse || authResponse?.pkp;
        console.log('authMethod', authMethod);
        sessionResponse = await WalletSessionCreate(pkp, authMethod);
      }
    } catch (e) {
      console.log('error', e);
      setLoading(false);
    }
  };
  return {
    runAuthFlow,
    loading,
    groupLoading: loading || !clients?.litNodeClient?.ready && !PKP && !litSession,
    setMFAInfo,
    currentAuthMethod,
    MFAInfo,
    googleLoader,
    appleLoader,
    ethWalletLoader,
    progressBar,
    mfaLoading
  };
};